export default __webpack_public_path__ + "static/media/sd-event-4.ac7856b1.png";